export const getLocalStorageData = <Type>(keyName: string, handler?: (d: Type) => Type): Type => {
    try {
        let data = localStorage.getItem(keyName);
        const result = JSON.parse(data ?? "");
        return handler ? handler(result) : result;
    } catch {
        return {} as Type;
    }
};

export const setLocalStorageData = <Type>(keyName: string, data: Type) => {
    localStorage.setItem(keyName, JSON.stringify(data));
};

export const removeLocalStorageData = <Type>(keyName: string) => {
    localStorage.removeItem(keyName);
};
